import { createTheme } from '@material-ui/core/styles';
// import { createTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';

// Create a theme instance.
const theme = createTheme({
  palette: {
    primary: {
      // main: "#556cd6",
      main: '#216FFB',
    },
    // secondary: {
    //   // main: "#19857b",
    //   main: '#04A6FB',
    //   contrastText: '#fff',
    // },
    // error: {
    // main: 'red.A400',
    // },
    background: {
      default: '#f5f5f5',
    },
  },
  overrides: {
    // Name of the component
    MuiButton: {
      root: {
        textTransform: 'none',
        borderRadius: '15px',
        boxShadow: 'none !important',
      },
      sizeLarge: {
        borderRadius: '22px',
        padding: '8px 21px',
        fontSize: '22px',
        lineHeight: '26px',
      },
      outlinedSizeLarge: {
        border: '2px solid #216FFB',
        fontWeight: 700,
        '&:hover': {
          borderWidth: '2px',
        }
      },
      containedSecondary: {
        color: 'white',
      },
    },

    MuiPaper: {
      rounded: {
        borderRadius: '15px',
      },
    },
    MuiBackdrop: {
      root: {
        backgroundColor: 'rgba(37, 110, 243, 0.51)',
      },
    },
    MuiTypography: {
      h6: {
        fontSize: '20px',
        fontWeight: 700,
        lineHeight: '23px',
      },
    },
    MuiDialog: {
      paperWidthXs: {
        maxWidth: '410px',
      }
    }
  },
});

export default theme;
